(function () {
  if (window.tmCartBackLinkBound) return;
  window.tmCartBackLinkBound = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.tm-continue-shopping-link');
    if (!link) return;

    var lastCollectionUrl;
    try {
      lastCollectionUrl = sessionStorage.getItem('tmLastCollectionUrl');
    } catch (e) {
      return;
    }

    if (!lastCollectionUrl) return;

    event.preventDefault();
    window.location.href = lastCollectionUrl;
  });
})();
